import Title from 'antd/lib/typography/Title';
import { Maybe } from 'graphql/jsutils/Maybe';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { extractTranslation } from '../../../helpers/formatters';
import { getAppointmentTypeName } from '../../../helpers/utils';
import {
  Resource_AppointmentLocation,
  Resource_AppointmentTypeMsg,
} from '../../../src/generated/graphql';
import { AppointmentRequestButton } from '../../common-layout/appointment-request-button';
import styles from '../facility-selection.module.scss';

interface AppointmentRequestProps {
  clinicId: Maybe<string> | undefined;
  officeHourId: Maybe<string> | undefined;

  appointmentType: Maybe<Resource_AppointmentTypeMsg> | undefined;
  appointmentLocation: Maybe<Resource_AppointmentLocation> | undefined;
}

export const AppointmentRequest: FC<AppointmentRequestProps> = ({
  appointmentType,
  appointmentLocation,
  officeHourId,
  clinicId,
}) => {
  const { formatMessage } = useIntl();

  const router = useRouter();

  const appointmentTypeName = extractTranslation(
    getAppointmentTypeName(appointmentType),
    router.locale,
  );

  return (
    <div className={styles.nextAvailableAppointmentsWrapper}>
      <Title level={3}>
        {formatMessage({
          id: 'facility-selection.appointment-request',
        })}
        {appointmentType && ` | ${appointmentTypeName}`}
      </Title>
      <p className={'ant-list-item-meta-description description'}>
        {formatMessage({
          id: 'facility-selection.appointment-request.description',
        })}
      </p>
      {officeHourId && (
        <AppointmentRequestButton
          appointmentLocation={appointmentLocation}
          clinicId={clinicId}
          slot={null}
          directBooking={false}
          officeHourId={officeHourId}
          note={null}
          timeFrameStart={null}
          timeFrameEnd={null}
          appointmentType={appointmentType}
        />
      )}
      {/*        <AveliosButton block type={"primary"} onClick={() => router.push("/slot-selection", {
          query: {
              appointmentLocation,
              appointmentTypeId: appointmentType?.id,
          },
      })}>{formatMessage({id: 'facility-selection.appointment-request.request'})}</AveliosButton>*/}
    </div>
  );
};
